/**
 * Padrões de validação compartilhados por validadores de SIP trunk
 * (zod-validations.ts e schemas/agent.schema.ts).
 *
 * Mantidos num módulo puro (sem i18n / sem deps) para serem testáveis e definidos
 * num único lugar — antes o regex SIP era duplicado inline nos dois arquivos.
 */

/** E.164: opcional `+`, primeiro dígito 1-9, total 2..15 dígitos. */
export const PHONE_REGEX = /^\+?[1-9]\d{1,14}$/;

/**
 * SIP URI no formato `user@domain.tld`.
 *
 * A parte do usuário (`[^@\s]+`) é idêntica à versão anterior — o `@` literal que
 * a segue é excluído da classe, então essa fronteira não tem ambiguidade.
 *
 * A parte do domínio foi endurecida contra ReDoS (SonarQube S5852): a forma antiga
 * `[^@\s]+\.[^@\s]+` permitia que o `.` casasse tanto na classe `[^@\s]` quanto no
 * `\.` literal, criando múltiplos pontos de divisão → backtracking polinomial em
 * entradas longas sem match. A forma `[^@\s.]+(?:\.[^@\s.]+)+` proíbe `.` dentro de
 * cada rótulo, então há exatamente uma maneira de dividir o domínio → tempo linear.
 *
 * Equivalência semântica: continua exigindo ≥1 ponto e rótulos não-vazios. A única
 * diferença é rejeitar domínios inválidos com pontos consecutivos (ex.: `a..b`),
 * que a forma antiga aceitava.
 */
export const SIP_URI_REGEX = /^[^@\s]+@[^@\s.]+(?:\.[^@\s.]+)+$/;
